import { create } from "zustand";

export type PdfErrorState = {
  open: boolean;
  message: string;
  messageParams?: Record<string, string>;
  onRetry?: () => void;
  show: (
    message: string,
    params?: Record<string, string>,
    onRetry?: () => void,
  ) => void;
  dismiss: () => void;
};

export const usePdfErrorStore = create<PdfErrorState>((set) => ({
  open: false,
  message: "",
  messageParams: undefined,
  onRetry: undefined,
  show: (message, params, onRetry) =>
    set({ open: true, message, messageParams: params, onRetry }),
  dismiss: () =>
    set({ open: false, messageParams: undefined, onRetry: undefined }),
}));
